<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-2" header="Parâmetros" header-tag="header">
            <div class="p-0 mb-2 col-12 text-right">
              <b-button
                v-if="btnNovoRegistro"
                variant="outline-secondary"
                @click.prevent="incluir"
                title=" Novo Parâmetro"
              >
                <font-awesome-icon
                  :icon="['fa', 'file']"
                  title=" Novo Parâmetro"
                  class="mr-1"
                />
                Novo Parâmetro
              </b-button>
            </div>

            <b-table
              no-provider-paging
              small
              responsive
              :current-page="tabela.currentPage"
              :empty-text="tabela.emptyText"
              :fields="tabela.fields"
              :items="tabela.items"
              :per-page="tabela.perPage"
              :show-empty="tabela.showEmpty"
              :striped="tabela.striped"
            >
              <template v-slot:cell(data_abertura_publico)="data">
                {{ $helpers.formatDateHourToDate(data.value) }}
              </template>

              <template v-slot:cell(data_fechamento_publico)="data">
                {{ $helpers.formatDateHourToDate(data.value) }}
              </template>

              <template v-slot:cell(editar)="data">
                <b-link
                  class="text-primary"
                  style="font-size: 18px"
                  v-if="habilitarEdicao(data.item)"
                  @click.prevent="editar(data.item)"
                  title="Editar"
                >
                  <font-awesome-icon :icon="['fas', 'edit']" title="Editar" />
                </b-link>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parametro from "../../../models/Parametro";

export default {
  data() {
    return {
      btnNovoRegistro: true,
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "data_abertura_publico",
            label: "Abertura Sistema",
            class: "text-center",
          },
          {
            key: "data_fechamento_publico",
            label: "Fechamento Sistema",
            class: "text-center",
          },
          {
            key: "ver",
            label: "",
            class: "text-center",
          },
          {
            key: "editar",
            label: "",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 12,
        totalRows: 0,
      },
    };
  },

  methods: {
    formatAno(ano) {
      return String(ano).substring(0, 4);
    },

    listar() {
      this.$api
        .get(`parametros`)
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = [];
            response.data.dados.forEach((element) => {
              let parametro = new Parametro(element);
              this.tabela.items.push(parametro);
              if (parametro.ind_ativo == "A") {
                this.btnNovoRegistro = false;
              }
            });
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    habilitarEdicao(item) {
      return item.ind_ativo == "A" ? true : false;
    },

    habilitarExclusao(mes, ano) {
      var dataParametro = new Date(ano, mes - 1, 1); //Primeiro dia do mes/ano as 00:00:00
      var hoje = new Date();
      return hoje.getTime() < dataParametro.getTime();
    },

    incluir() {
      this.$router.push({ name: "parametrosform", params: { id: "new" } });
    },

    editar(parametro) {
      this.$router.push({
        name: "parametrosform",
        params: { id: parametro.id },
      });
    },

    excluir(parametro) {
      this.$helpers.confirmaExclusao(this).then((value) => {
        if (value) {
          this.$api
            .delete(`parametros/${parametro.id}`)
            .then((response) => {
              if (response.status == 200) {
                this.listar();
                this.$helpers.showToast(
                  this,
                  "Sucesso",
                  response.data.message,
                  "success"
                );
              }
            })
            .catch((error) => {
              if (error.response.data) {
                this.$helpers.showToast(
                  this,
                  "Erro",
                  error.response.data.message,
                  "danger"
                );
              }
            });
        }
      });
    },
  },

  mounted() {

    this.listar();
  },
};
</script>

<style scoped>
</style>
